import { render, staticRenderFns } from "./default.vue?vue&type=template&id=f5718848&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=f5718848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5718848",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MobileNav: require('/var/app/components/Mobile/Nav.vue').default,DesktopNav: require('/var/app/components/Desktop/Nav.vue').default,MobileFooter: require('/var/app/components/Mobile/Footer.vue').default,DesktopFooter: require('/var/app/components/Desktop/Footer.vue').default})
